import React, { useEffect, useState } from 'react';
import { formatCountdownUnit, getCountdownParts } from '../../lib/banner-countdown';

const UNITS = [
  { key: 'days', label: 'Days' },
  { key: 'hours', label: 'Hours' },
  { key: 'minutes', label: 'Min' },
  { key: 'seconds', label: 'Sec' },
] as const;

interface BannerCountdownProps {
  endsAt: string;
  label?: string | null;
}

export function BannerCountdown({ endsAt, label }: BannerCountdownProps) {
  const [parts, setParts] = useState(() => getCountdownParts(new Date(endsAt)));

  useEffect(() => {
    const target = new Date(endsAt);
    const tick = () => setParts(getCountdownParts(target));
    tick();
    const id = window.setInterval(tick, 1000);
    return () => window.clearInterval(id);
  }, [endsAt]);

  return (
    <div className="mt-5 pt-5 border-t border-[var(--color-border)]">
      {label ? (
        <p className="text-sm font-medium text-[var(--color-text-primary)] mb-3">{label}</p>
      ) : null}
      {parts.expired ? (
        <p className="text-sm text-[var(--color-text-secondary)]">The countdown has ended.</p>
      ) : (
        <div className="grid grid-cols-4 gap-2 sm:gap-3 max-w-sm" role="timer" aria-live="polite">
          {UNITS.map(({ key, label: unitLabel }) => (
            <div
              key={key}
              className="bg-[var(--color-surface-2)] rounded-[var(--radius-md)] px-2 py-3 text-center border border-[var(--color-border)]"
            >
              <span className="block text-xl sm:text-2xl font-semibold tabular-nums text-[var(--color-accent)] leading-tight">
                {formatCountdownUnit(parts[key])}
              </span>
              <span className="block text-[10px] sm:text-xs font-medium uppercase tracking-wide text-[var(--color-text-tertiary)] mt-1">
                {unitLabel}
              </span>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
